import React, { Component, PropTypes } from 'react';
import Hammer from 'hammerjs';
import { findDOMNode } from 'react-dom';

const privateProps = {
  component: true,
  children: true,
  action: true,
  onTap: true,
  onDoubleTap: true,
  onPan: true,
  onSwipe: true,
  onPress: true,
  onPinch: true,
  onRotate: true
};

export default class HammerWrapper extends Component {
  static displayName = 'Hammer';

  static propTypes = {
    component: PropTypes.any,
    className: PropTypes.string
  };

  static defaultProps = {
    component: 'span'
  };

  componentDidMount() {
    this.hammer = new Hammer(findDOMNode(this));

    if (this.props.options) {
      Object.keys(this.props.options).forEach(option => {
        if (option === 'recognizers') {
          Object.keys(this.props.options.recognizers).forEach(gesture => {
            this.hammer
              .get(gesture)
              .set(this.props.options.recognizers[gesture]);
          });
        } else {
          let key = option,
            optionObj = {};
          optionObj[key] = this.props.options[option];
          this.hammer.set(optionObj);
        }
      });
    }

    if (this.props.vertical) {
      this.hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
      this.hammer.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
    }

    if (this.props.action) this.hammer.on('tap press', this.props.action);
    if (this.props.onTap) this.hammer.on('tap', this.props.onTap);
    if (this.props.onDoubleTap)
      this.hammer.on('doubletap', this.props.onDoubleTap);
    if (this.props.onPan) this.hammer.on('pan', this.props.onPan);
    if (this.props.onPanStart)
      this.hammer.on('panstart', this.props.onPanStart);
    if (this.props.onPanEnd) this.hammer.on('panend', this.props.onPanEnd);
    if (this.props.onSwipe) this.hammer.on('swipe', this.props.onSwipe);
    if (this.props.onPress) this.hammer.on('press', this.props.onPress);
    if (this.props.onPinch) this.hammer.on('pinch', this.props.onPinch);
    if (this.props.onRotate) this.hammer.on('rotate', this.props.onRotate);
  }

  componentWillUnmount() {
    if (this.hammer) {
      this.hammer.stop();
      this.hammer.destroy();
    }
    this.hammer = null;
  }

  render() {
    const props = {};

    Object.keys(this.props).forEach(i => {
      if (!privateProps[i]) {
        props[i] = this.props[i];
      }
    });

    return React.createElement(
      this.props.component,
      props,
      this.props.children
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/HammerWrapper.js